import AccordienListItemDynamicSvg from "./accordienListItemDynamicSvg";
export default AccordienListItemDynamicSvg;